import React, { forwardRef } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { setActionsPreference } from '../actions'
import { DarkModeButton as DarkModeButtonInner } from './ui/DarkModeButton'
import { TOOLTIP_MAIN } from './utils/tooltipIds'

export const Button = forwardRef(
  ({ darkMode, setPreference, ...rest }, ref) => {
    return (
      <DarkModeButtonInner
        key={darkMode ? 'dark' : 'light'}
        ref={ref}
        enabled={darkMode}
        onClick={() => setPreference({ darkMode: !darkMode })}
        aria-label={darkMode ? 'Set light mode' : 'Set dark mode'}
        data-tooltip-id={TOOLTIP_MAIN}
        data-tooltip-content={darkMode ? 'Light mode' : 'Dark mode'}
        data-tooltip-place="bottom"
        data-tooltip-delay-show={300}
        {...rest}
      />
    )
  },
)

const mapStateToProps = (state) => ({
  darkMode: get(state, 'preferences.actions.darkMode', false),
})
const DarkModeButton = connect(mapStateToProps, {
  setPreference: setActionsPreference,
})(Button)

export default DarkModeButton
